import { render, staticRenderFns } from "./wxjsapi.vue?vue&type=template&id=0a886dd8&scoped=true"
import script from "./wxjsapi.vue?vue&type=script&lang=js"
export * from "./wxjsapi.vue?vue&type=script&lang=js"
import style0 from "./wxjsapi.vue?vue&type=style&index=0&id=0a886dd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a886dd8",
  null
  
)

export default component.exports